import React from 'react';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import Services from './components/pages/Services';
import Products from './components/pages/Products';
import SignUp from './components/pages/SignUp';
import MyEvents from './components/pages/MyEvents';
import UploadImages from './components/pages/UploadImages';
import createNewEvent from './components/pages/create-new-event';
import SignIn from './components/pages/SignIn';
import EventDetails from './components/pages/EventDetails';
import QRCodeScanner from './components/pages/QRCodeScanner';
import GuestsDetails from './components/pages/guestsDetails';
import ImageGallery from './components/pages/ImageGalleryTest';
import ImageGalleryManager from './components/pages/ImageGalleryManagerTest';
import MyEventNew from './components/pages/MyEventNew';
import UpdateEvent from './components/pages/UpdateEvent';
import ContactCard from './components/pages/ContactCard';
import UserProfile from './components/pages/UserProfile';
import GoRedirectHandler from './components/pages/GoRedirectHandler';
import AccessibilityStatement from './components/pages/AccessibilityStatement';
import Privacy from './components/pages/Privacy';

import Terms from './components/pages/Terms';
import Info from './components/pages/info';

import languageMap from './components/languageMap';

function AppContent() {
  const selectedLanguage = languageMap.config.selectedLanguage;
  document.body.dir = selectedLanguage === 'he' ? 'rtl' : 'ltr';

  // Use `useLocation` to determine the current route
  const location = useLocation();

  // Define an array of routes where the Navbar should not appear
  const noNavbarRoutes = [
    '/SignIn',
    '/QR',
    '/gallery',
    '/GuestsDetails',
    '/UploadImages',
  ];

  // Check if the current path matches any route in `noNavbarRoutes`
  const shouldShowNavbar = !noNavbarRoutes.includes(location.pathname);

  return (
    <>
      {/* Conditionally render the Navbar */}
      <Switch>
        <Route path="/home" exact component={Home} />
        <Route path="/services" component={Services} />
        <Route path="/products" component={Products} />
        <Route path="/sign-up" component={SignUp} />
        <Route path="/sign-in" component={SignIn} />
        <Route path="/MyEvents" component={MyEvents} />
        <Route path="/MyEvents/:username" component={MyEvents} />
        <Route path="/UploadImages" component={UploadImages} />
        <Route path="/create-new-event" component={createNewEvent} />
        <Route path="/update-event" component={UpdateEvent} />
        <Route path="/event-details/:eventId" component={EventDetails} />
        <Route path="/QR" exact component={QRCodeScanner} />
        <Route path="/GuestsDetails" exact component={GuestsDetails} />
        <Route path="/gallery" exact component={ImageGallery} />
        <Route path="/gallery-manager" exact component={ImageGalleryManager} />
        <Route path="/events" exact component={MyEventNew} />
        <Route path="/contact" exact component={ContactCard} />
        <Route path="/user-details/:id" exact component={UserProfile} />
        <Route path="/go/:code" component={GoRedirectHandler} />
        <Route path="/accessibility" exact component={AccessibilityStatement} />
        <Route path="/terms" exact component={Terms} />
        <Route path="/privacy" exact component={Privacy} />

        <Route path="/" component={Info} />
        

      </Switch>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
